<template>
  <div class="home">
    <img class="logo" :src="`${publiPath}/schoolLogo.png`" :style="{ width: ismob ? '30%' : '200px' }" />

    <div class="center-btn" v-if="ismob && !navigator">
      <!-- <el-button type="primary" plain @click="openWxminpg">跳转无感登录</el-button> -->
      <img src="../assets/minipg-backg-content.png" alt="" />

      <el-button type="primary" round @click="openWxminpg" class="btn"
        >前往微信认证 <i class="el-icon-arrow-right el-icon--right"></i
      ></el-button>
    </div>

    <div class="centerContent" v-if="!ismob">
      <div class="titleContent">
        <div class="log">
          <login></login>
        </div>
      </div>
      <div class="title">
        <span>统一身份认证系统</span>
      </div>
    </div>
    <p class="version">V2.1.5 build-210826 without-logout</p>
  </div>
</template>
<script>
import login from "./login";
export default {
  data() {
    return {
      activeName: "one",
      publiPath: process.env.BASE_URL,
      navigator: "",
    };
  },
  computed: {
    ismob() {
      return window.screen.width < 500;
    },
  },
  methods: {
    getEnvironment() {
      //判断当前环境（微信/其他）
      let ua = navigator.userAgent.toLowerCase();
      this.navigator = ua.match(/MicroMessenger/i) == "micromessenger"; //true在微信浏览器中
    },
    openWxminpg() {
      let path = this.$route.query.extjump;
      let pbkey = this.$route.query.extkey;
      let extsign = this.$route.query.extsign;
      let timestamp = this.$route.query.extlgt;

      // const domain = document.location.href.split("#")[0];

      let query = { path, pbkey, extsign, timestamp };
      let queryString = Object.keys(query)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
        .join("&");
      queryString = encodeURIComponent(queryString);

      window.location.href =
        "weixin://dl/business/?appid=wx9a8a45ff3ce4abe7&path=pages/index/index&query=" +
        queryString +
        "&env_version=release";
      //env_version： 正式版为release，体验版为trial，开发版为develop，仅在微信外打开时生效
    },
  },
  components: {
    login,
  },
};
</script>
<style scoped>
.home {
  background: #fbfcff url("../assets/backg.png") no-repeat fixed center;
  background-size: 100% auto;
  height: 100vh;
}
.centerContent {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: 700px;
  width: 70em;
  background: white;
  margin: auto;
  position: relative;
  top: 100px;
  background: #fbfcff url("../assets/loginBackg.png") no-repeat content-box center;
  background-size: 100% auto;
}
.title {
  background: #bf3636;
  height: 60px;
  width: 320px;
  position: relative;
  top: 60px;
  left: -20px;
  padding: auto;
}
.title::after {
  content: "";
  width: 0;
  height: 0;
  border-bottom: 60px solid #bf3636;
  /* border-bottom: 80px solid white; */
  border-right: 50px solid transparent;
  position: absolute;
  top: 0px;
  right: -50px;
}
.title span {
  color: white;
  font-weight: 800;
  font-size: 30px;
  line-height: 60px;
  padding-left: 50px;
}
.titleContent {
  background: rgba(255, 255, 255, 0.3);
  position: relative;
  float: right;
  width: 50%;
  height: 100%;
}
.log {
  width: 500px;
  margin: 100px auto;
  font-family: "Microsoft YaHei";
}
.version {
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  color: #e6e6e6;
  font-size: 14px;
  z-index: 0;
}

.center-btn {
  width: 100%;
  height: 100vh;
  background: url("../assets/minipg-backg.png") no-repeat top center;
  background-size: 100% auto;
  overflow: hidden;
}
.center-btn > img {
  width: 80%;
  margin: 12vh auto;
  height: auto;
}
.center-btn > .btn {
  position: relative;
  bottom: 10px;
}
</style>
<style>
.logo {
  left: 30px;
  position: absolute;
  margin-top: 10px;
}
</style>
